import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';
import { ActivatedRoute } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { ICaseFile } from '../../../interfaces/case-file.interface';

enum texts {
  title = 'Crear caso',
  editTitle = 'Editar caso',
  create = 'Crear',
  edit = 'Editar',
}

@Component({
  selector: 'fraude-form',
  templateUrl: './fraude-form.component.html',
  styleUrls: ['./fraude-form.component.scss'],
})
export class FraudeFormComponent implements OnInit {
  public Texts = texts;
  additionalFormValid: boolean = true;
  aditionalInfoForm: any = null;
  caseId: string = null;
  createCase: boolean = false;
  unit: IUnit;
  constructor(
    private readonly casesService: CasesService,
    public readonly userService: UserService,
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly unitsService: UnitsService,
    private readonly dialogRef: MatDialogRef<FraudeFormComponent>,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      unit: string;

      case?: any; //cambiar
    }
  ) {
    this.getUnit(this.data.unit);
  }
  typeOfPerson = ['V', 'E', 'P', 'J', 'R', 'I', 'G'];

  form = this.fb.group({
    caseType: ['', [Validators.required]],
    description: ['', [Validators.required]],
  });
  fraudeForm = this.fb.group({
    tipo_de_persona: ['', [Validators.required]],
    numero_de_identificacion: ['', [Validators.required]],
    apellido: ['', [Validators.required]],
    nombre: ['', [Validators.required]],
    oficina: ['', [Validators.required]],
    region: ['', [Validators.required]],
    telefono: ['', [Validators.required]],
    correo: ['', [Validators.required, Validators.email]],
    celular: ['', [Validators.required]],
    cliente: ['', [Validators.required]],
    domicilio: ['', [Validators.required]],
    tipo_registro: [''],
    canal: ['', [Validators.required]],
    instrumento: ['', [Validators.required]],
    descripcion: ['', [Validators.required]],
    datos_instrumento: ['', [Validators.required]],
    monto_salio: ['', [Validators.required]],
  });

  get caseType() {
    if (this.isEditing) {
      return this.data.case.caseType._id;
    } else {
      return this.form.get('caseType').value;
    }
  }

  get isEditing() {
    return !!this.data?.case;
  }

  caseTypes: ICaseType[] = [];
  oficinasExample: any[] = ['oficina 1', 'oficina 2', 'oficina 3'];
  regionesExample: any[] = ['región 1', 'región 2', 'región 3'];
  canalesExample: any[] = [
    'ATM',
    'BDV en línea',
    'clavenet',
    'pago clave pos',
    'sms',
    'taquillas',
  ];
  instrumentosExample: any[] = [
    'Tarjeta / Cuenta',
    'Número de tarjeta / Cuenta',
  ];

  ngOnInit() {
    this.getCaseTypes();
    if (this.isEditing) {
      const caseEdit = this.data.case;

      let data = {
        caseType: caseEdit.caseType._id,
        assigned: caseEdit.assigned?._id || null,
        description: caseEdit.description,
      };
      this.form.patchValue(data);
      this.fraudeForm.patchValue(caseEdit.additionalInformation);

      this.form.get('caseType').disable();
      this.casesService.getFiles(caseEdit._id).subscribe({
        next: (files) => {
          this.files = files;
        },
      });
    }
  }

  async findUser() {
    let caseType = this.caseTypes.find((item) => item._id == this.caseType);
    const roles = caseType.role;
    const users: IUser[] = [];

    for (const role of roles) {
      const usersByRole = await this.userService
        .getUsersByRole(role)
        .toPromise();
      users.push(...usersByRole);
    }

    this.users = users;
  }

  users: IUser[] = [];

  getCaseTypes() {
    this.unitsService.getTypeCases(this.data.unit).subscribe({
      next: (caseTypes) => {
        this.caseTypes = caseTypes;
        this.form.value.caseType = this.caseTypes[0]._id;
        if (this.caseType) {
          this.findUser();
        }
      },
    });
  }

  files: ICaseFile[] = [];
  newFiles: ICaseFile[] = [];
  deleteFiles: ICaseFile[] = [];

  closeModal() {
    this.dialogRef.close();
  }

  save() {
    if (this.isEditing) {
      this.edit();
    } else {
      this.create();
    }
  }

  edit() {
    this.isLoading = true;

    const data = this.form.value;

    data.caseType = this.data.case.caseType._id;
    data.newFiles = this.newFiles;
    data.deleteFiles = this.deleteFiles;
    data.additionalInformation = this.fraudeForm.value;
    if (data.status != this.data.case.status) {
      switch (data.status) {
        case 'initial':
          data.initialAt = new Date();
          break;
        case 'running':
          data.runningAt = new Date();
          break;
        case 'tobeApproved':
          data.tobeApprovedAt = new Date();

          break;
        case 'toFinalize':
          data.toFinalizeAt = new Date();
          break;
        default:
          break;
      }
    }

    data.user_changing = this.userService.currentUser._id;

    this.casesService.update(this.data.case._id, data).subscribe({
      next: (caseUpdated: any) => {
        // this.casesService
        //   .saveAuditory('EditCase', caseUpdated)
        //   .subscribe((res) => console.log(' '));
        this.isLoading = false;
        this.alert('Caso editado con éxito');
        this.caseId = caseUpdated._id;
        this.createCase = true;

        caseUpdated.additionalInformation = this.aditionalInfoForm;
        if (typeof caseUpdated.caseType.unit == 'object') {
          caseUpdated.caseType.unit = caseUpdated.caseType.unit._id;
        }

        this.dialogRef.close(caseUpdated);
      },
      error: (err) => {
        console.log(err);

        this.alert(err.error);
        this.isLoading = false;
      },
    });
  }

  isLoading = false;

  alert(title: string) {
    this.dialog.open(SuccessComponent, {
      data: { title },
    });
  }

  additionalFormValidChange(info: any) {
    this.additionalFormValid = info.val;
    this.aditionalInfoForm = info.additionalInformation;
  }

  create() {
    this.isLoading = true;
    const data = this.form.value;
    data.files = this.files;
    data.caseType = this.caseTypes[0]._id;
    this.fraudeForm.value.tipo_registro = 'Manual';
    data.additionalInformation = this.fraudeForm.value;

    this.casesService.create(data).subscribe({
      next: (caseCreated: any) => {
        // this.casesService
        //   .saveAuditory('CreateCase', caseCreated)
        //   .subscribe((res) => console.log(''));
        this.isLoading = false;
        this.alert('Caso creado con éxito!');
        this.caseId = caseCreated._id;
        this.createCase = true;
        caseCreated.additionalInformation = this.aditionalInfoForm;
        if (typeof caseCreated.caseType.unit == 'object') {
          caseCreated.caseType.unit = caseCreated.caseType.unit._id;
        }

        if (
          (this.userService.currentUser.role.createCases &&
            this.userService.currentUser.role.editCases) ||
          caseCreated.assigned._id == this.userService.currentUser._id
        ) {
          this.casesService.caseCreated.next(caseCreated);
        }
        this.dialogRef.close();
      },
      error: (err) => {
        console.log(err);

        this.alert(err.error);
        this.isLoading = false;
      },
    });
  }

  //Obtener la unidad en la que se encuentra
  async getUnit(id) {
    await this.unitsService.getById(id).subscribe((res) => {
      this.unit = res;
    });
  }
  changeCi() {
    // if (this.form.value.numero_de_identificacion) {
    let ci = this.fraudeForm.value.numero_de_identificacion;
    if (ci != '') {
      ci = ci.split('');
      if (
        !this.includesLetter(this.fraudeForm.value.numero_de_identificacion)
      ) {
        ci.splice(0, 0, this.fraudeForm.value.tipo_de_persona[0].toUpperCase());
      } else {
        ci.splice(0, 1, this.fraudeForm.value.tipo_de_persona[0].toUpperCase());
      }
      ci = ci.join('');
    } else {
      ci = this.fraudeForm.value.tipo_de_persona[0].toUpperCase();
    }
    // ci[0] = this.fraudeForm.value.tipo_de_persona[0].toLowerCase();
    this.fraudeForm.controls.numero_de_identificacion.setValue(ci);
    // }
  }
  includesLetter(ci: any) {
    for (let type of this.typeOfPerson) {
      if (ci.includes(type)) {
        return ci.includes(type);
      }
    }
  }
}
